import React, { useState, useEffect } from 'react';
import shuffle from 'lodash/shuffle';
import salary_icon from '../../../images/icons/salary_icon.svg';
import self_Employed_Professional from '../../../images/icons/self_Employed_Professional.svg';
import self_Employed from '../../../images/icons/self_Employed.svg';
import CommonProfession from './CommonProfession';
import styles from './IncomeDetails.module.css';
import { useFormikContext } from 'formik';
import { useFormikWizard } from 'formik-wizard';
import PopUp from '../../../common/components/PopUp/PopUp';
import Modal from '../../../common/components/Modal/modal';
import SelectedWrapper from '../../../common/components/SelectWrapper/SelectWrapper';
import { getProfessionType } from '../../../common/constants/api';
import { getApplicantionInfo } from '../../../common/utils/applicantionInfo';
import CircularLoading from '../../../common/components/CircularLoading/CircularLoading';
import { addProfession } from '../../../common/constants/api';
import { navigate } from 'gatsby';
import { staticData } from 'gatsby-env-variables';
const Modaltext = {
  position: 'relative',
  top: '-26px',
  width: '300px'
};
const serverData = [
  {
    imgUrl: salary_icon,
    profession: 'Salaried',
    value: 'SALARIED'
  },
  {
    imgUrl: self_Employed,
    profession: 'Self Employed',
    value: 'SELF_EMPLOYED'
  },
  {
    imgUrl: self_Employed_Professional,
    profession: (
      <div>
        <div>Self Employed Professional </div>
        <span className="text-black-600"> Doctor | CA | Architect</span>
      </div>
    ),
    value: 'SELF_EMPLOYED_PROFESSION'
  }
];

let bgAndTextColors = [
  {
    bgcolor: '#c1eae2',
    textcolor: '#0b8f98'
  },
  {
    bgcolor: '#fcc683',
    textcolor: '#c48233'
  },
  {
    bgcolor: '#f5c9c0',
    textcolor: '#cc543b'
  }
];

function ChooseProfession() {
  const { profession_details_box } = styles;
  const [show, setShow] = useState(false);
  const [showCommingSoon, setShowCommingSoon] = useState(false);
  const [commingSoonText, setCommingSoonText] = useState('');
  const [selectedType, setSelectedType] = useState('');
  const [selectedId, setSelectedId] = useState('');
  const [isGetOver, setGetOver] = useState(false);
  const [statusMessage, setMessage] = useState('');
  function handleSelectData(anyselected) {
    setSelectedType(anyselected.value);
  }

  const onClickHandler = id => {
    setSelectedId(id);
  };

  useEffect(() => {
    if (
      selectedType === 'SALARIED' ||
      selectedType == 'SELF_EMPLOYED' ||
      selectedType == 'SELF_EMPLOYED_PROFESSION'
    ) {
      let data = getApplicantionInfo();
      const { leadId, leadApplicantId } = data;
      addProfession(
        leadId,
        leadApplicantId,
        selectedType == 'SELF_EMPLOYED_PROFESSION'
          ? 'SELF_EMPLOYED_PROFESSIONAL'
          : selectedType
      )
        .then(() => {
          if (selectedType == 'SELF_EMPLOYED') {
            navigate(staticData?.senpUrl || '/user/income/senp');
          } else if (selectedType == 'SELF_EMPLOYED_PROFESSION') {
            navigate(staticData?.sepUrl || '/user/income/sep');
          } else {
            navigate(staticData?.salariedUrl || '/user/income/salaried');
          }
        })
        .catch(error => {
          setShow(true);
          setMessage(error?.response?.data?.message);
        });
    }
  }, [selectedType]);
  bgAndTextColors = shuffle(bgAndTextColors);

  useEffect(() => {
    getProfessionType(
      getApplicantionInfo().leadId,
      getApplicantionInfo().leadApplicantId
    )
      .then(res => {
        setGetOver(true);

        if (res?.professionType === 'SALARIED') {
          setSelectedId(0);
        }
        if (res?.professionType === 'SELF_EMPLOYED') {
          setSelectedId(1);
        }
        if (res?.professionType === 'SELF_EMPLOYED_PROFESSIONAL') {
          setSelectedId(2);
        }
      })
      .catch(err => {
        setGetOver(true);
      });
  }, []);

  return isGetOver ? (
    <div>
      <h1 className="text-center text-2xl py-4 font-khand text-xl font-semibold">
        Choose Your Profession
      </h1>
      <p
        className="font-roboto ml-auto mr-4 float-right mt-4 md:mt-1 xmd:mt-2  pb-2 text-red-100 font-medium text-base bottom-0 mx-auto md:mr-5 cursor-pointer float-right"
        onClick={() => navigate(staticData?.propertyDetailsURl||'/user/propertyDetails')}
      >
        Skip For Now
      </p>
      <div
        className={`${profession_details_box} m-2 md:mx-auto p-6 py-10 md:p-8 
       bg-white shadow-lg rounded-lg xmd:flex xmd:flex-row xmd:justify-around xmd:p-0 xmd:mx-2 xmd:shadow-none max-w-full`}
      >
        {serverData.map((each, index) => {
          return (
            <SelectedWrapper
              key={index}
              onClick={onClickHandler}
              id={index}
              selectedId={selectedId}
            >
              <CommonProfession
                key={each.profession}
                sendUrl={each.imgUrl}
                sendloanType={each.profession}
                randomColor={bgAndTextColors[index]}
                handleSelectData={() => {
                  handleSelectData(each);
                }}
              />
            </SelectedWrapper>
          );
        })}
      </div>
      {showCommingSoon && (
        <Modal
          show={show}
          setShow={setShow}
          styleContainer={{
            width: '395px'
          }}
        >
          <>
            <div
              className={` text-grey-920 text-base font-roboto font-medium`}
              style={Modaltext}
            >
              {commingSoonText}
            </div>
            <div
              style={{
                borderBottom: '1px solid #DCE9F5',
                position: 'relative',
                top: '-15px'
              }}
            >
              <h1 className="text-center p-5">Coming Soon</h1>
            </div>
          </>
        </Modal>
      )}
      {statusMessage ? (
        <PopUp
          type="fail"
          text={statusMessage}
          show={show}
          setShow={setShow}
        ></PopUp>
      ) : null}
    </div>
  ) : (
    <CircularLoading />
  );
}
export default ChooseProfession;
